import { render, staticRenderFns } from "./EditDomain.vue?vue&type=template&id=4daae548&"
import script from "./EditDomain.vue?vue&type=script&lang=js&"
export * from "./EditDomain.vue?vue&type=script&lang=js&"
import style0 from "./EditDomain.vue?vue&type=style&index=0&id=4daae548&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports